import * as z from 'zod';

import { brandQueryLinkerSchema } from '@/_pages/settings/brands/shared';
import { companyQueryLinkerSchema } from '@/_schemas/companies/company-query-linker-schema';
import { fileQuerySchema } from '@/_schemas/file';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

import { awardQueryLinkerSchema } from './award-query-linker-schema';

import { awardTypeQuerySchema } from '../components/award-type';

export const awardQuerySchema = z.object({
  ...awardQueryLinkerSchema.shape,

  award_month: z.number().nullish(),
  award_year: z.number().nullish(),

  sponsoring_organization: z.string().nullish(),
  brand_id: z.number().nullish(),
  brand: brandQueryLinkerSchema.nullable(),

  award_type: awardTypeQuerySchema.nullable(),

  client_id: z.number().nullish(),
  client: companyQueryLinkerSchema.nullable(),
  notes: z.string().nullish(),
  gallery: z.array(fileQuerySchema).nullish(),
});

export type AwardQuerySchema = z.infer<typeof awardQuerySchema>;

export const awardQueryAllSchema = paginatedResponseSchema(awardQuerySchema);

export type AwardQueryAllSchema = z.infer<typeof awardQueryAllSchema>;
